module.exports = __webpack_public_path__ + "static/media/bananella-connect.a5308c08.png";